import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import Table from "../../components/Table";
import { Link } from "react-router-dom";
import { MerakiDevicecolumns } from "../../components/headerContent";
import Loader from "../../components/Loader";
import RowMerakiIot from "./RowMerakiIoT";
import { useTranslation } from "react-i18next";

const storybookMerakiCameraFallback = [
  {
    name: "MV63 Camera",
    model: "MV63",
    serial: "Q2WW-GGGG-HHHH",
    mac: "00:11:22:33:44:88",
    networkId: "net-paris",
    status: "online",
    productType: "camera",
    publicIp: "81.250.10.15",
    lastReportedAt: "2026-04-22T08:31:00.000Z",
    storybookOverview: [
      {
        zoneId: "Entrance",
        entrances: 42,
        startTs: "2026-04-22T08:00:00.000Z",
        endTs: "2026-04-22T08:30:00.000Z"
      },
      {
        zoneId: "Lobby",
        entrances: 18,
        startTs: "2026-04-22T08:00:00.000Z",
        endTs: "2026-04-22T08:30:00.000Z"
      }
    ],
    storybookLive: {
      zones: {
        Entrance: { person: 3 },
        Lobby: { person: 1 }
      }
    }
  },
  {
    name: "MV72 Entrance",
    model: "MV72",
    serial: "Q2VV-IIII-JJJJ",
    mac: "00:11:22:33:44:99",
    networkId: "net-lyon",
    status: "online",
    productType: "camera",
    publicIp: "81.250.10.16",
    lastReportedAt: "2026-04-22T08:27:00.000Z",
    storybookOverview: [
      {
        zoneId: "Reception",
        entrances: 26,
        startTs: "2026-04-22T08:00:00.000Z",
        endTs: "2026-04-22T08:30:00.000Z"
      }
    ],
    storybookLive: {
      zones: {
        Reception: { person: 2 }
      }
    }
  }
];

export default function MerakiIoT() {
  const { apiUrl, user } = useContext(AuthContext);
  const { t } = useTranslation();

  const getDevicesStatus = async () => {
    try {
      const res = await axios.get(`${apiUrl}meraki/devices_status`, {
        withCredentials: true,
      });
      const cameraDevices = Array.isArray(res.data)
        ? res.data.filter(device => device.productType === "camera")
        : [];

      if (cameraDevices.length > 0) {
        return cameraDevices;
      }

      if (apiUrl === "/") {
        return storybookMerakiCameraFallback;
      }

      return cameraDevices;
    } catch (error) {
      if (apiUrl === "/") {
        return storybookMerakiCameraFallback;
      }
      return [];
    }
  };

  const devicesStatus = useQuery({
    queryKey: ["merakiDeviceStatus"],
    queryFn: getDevicesStatus,
  });

  const cameraDevices = Array.isArray(devicesStatus.data) ? devicesStatus.data : [];


  if (devicesStatus.isFetched) {

    if (cameraDevices.length === 0) {
      return (
        <div className="ecp-container">
          <div className="ecp-container-content-error">
            <div className="error-container">
              <img src='../assets/ecp_error.svg' alt="icône d'erreur" />
              <div className="error-container-text">
                <h1 className="page-title">
                  {t("Aucune caméra détectée")}
                </h1>
                <p className="page-link_home">
                  <Link to="/"> {t("Revenir à l'accueil")}</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      )
    }
  }


  return (
    <>
      {!devicesStatus.isLoading ? (
        <div className='cato-content-table mt-1'>
          <Table
            tableColumns={MerakiDevicecolumns}
            tableData={cameraDevices}
            checkbox={false}
            rowComponent={RowMerakiIot}
          />
        </div>
      ) : (
        <Loader />
      )}
    </>
  );
}
